module.exports = "/static/assets/965ea130b37b735c280e194c78001464.png";